<template>
  <div class='main'>
    <div class="message">
      <van-collapse v-model="activeNames">

        <van-collapse-item name="1" v-if="accountFlag == '1'" class="backCollapseItem">
          <template #title>
            <div class="activeTitles">账号信息</div>
          </template>
          <ul class="messageUl">
            <li><span class="liL">收款人姓名</span>
              <p class="liR" :class="{'noGrey':payeeName != '请填写收款人姓名'}"><input type="text" placeholder="请填写收款人姓名"
                                                                                v-model="payeeName"></p>
            </li>
            <li><span class="liL">收款人身份证号</span>
              <p class="liR" :class="{'noGrey':payeeCertNo != '请填写收款人身份证号'}"><input type="text" placeholder="请填写收款人身份证号"
                                                                                    v-model="payeeCertNo"></p>
            </li>
            <li><span class="liL">收款人电话</span>
              <p class="liR" :class="{'noGrey':payeePhone != '请填写收款人电话'}"><input type="number" placeholder="请填写收款人电话"
                                                                                 v-model="payeePhone"></p>
            </li>
            <li><span class="liL">银行名称</span>
              <p class="liR" :class="{'noGrey':bankName != '请填写银行名称'}">
                <!--<input type="text" placeholder="请填写银行名称" v-model="bankName">-->
                <van-field
                  v-model="bankName"
                  rows="1"
                  autosize
                  type="textarea"
                  placeholder="请填写银行名称"
                />
              </p>
            </li>
            <li><span class="liL">银行账号</span>
              <p class="liR" :class="{'noGrey':bankCode != '请填写银行账号'}">
                <input type="text" placeholder="请填写银行账号" v-model="bankCode"></p>
              <div class="bankList" v-if="bankListFlag"><span v-for="(item, index) in bankList" :key="index" @click="selBankList(item)">
                {{item.bankName}}
              </span></div>
            </li>
            <li><span class="liL">银行所在省份</span>
              <p class="liR" :class="{'noGrey':bankProvinceName != '请填写银行所在省份'}"><input type="text"
                                                                                        placeholder="请填写银行所在省份"
                                                                                        v-model="bankProvinceName"></p>
            </li>
            <li><span class="liL">银行所在地市</span>
              <p class="liR" :class="{'noGrey':bankCityName != '请填写银行所在地市'}"><input type="text" placeholder="请填写银行所在地市"
                                                                                    v-model="bankCityName"></p>
            </li>
            <li><span class="liL">开户支行</span>
              <!-- <p class="liR" :class="{'noGrey':bankSubName != '请填写开户支行'}"><input type="text" placeholder="请填写开户支行"
                                                                                    v-model="bankSubName"></p> -->
              <p class="liR" :class="{'noGrey':bankSubName != '请填写开户支行'}" style="position: relative;">
                <el-input v-model="bankSubName" placeholder="请填写开户支行" @focus="bankSubNameClick" @input="querySubBank(bankSubName)" @blur="bankSubNameBlur"></el-input>
                <ul v-if="subBankList.length >0" style="position: absolute;width: 100%;" v-show="bankSubSelectShow" class="bankSubNameSelectDwon">
                  <li v-for="(item,index) in subBankList" :key="index" @mousedown="bankSubName = item">{{ item }}</li>
                </ul>
              </p>
            </li>
          </ul>
        </van-collapse-item>
        <van-collapse-item title="挂科信息" name="2">
          <ul class="messageUl">
            <li><span class="liL">挂科日期<i style="font-size: 12px;font-style: normal;">(当次挂科日期)</i></span>
              <p class="liR sel" :class="{'noGrey':selCurrentDate != '请选择挂科日期'}" @click="openDatetime"><span>{{selCurrentDate}}</span>
              </p></li>
            <li><span class="liL">挂科省</span>
              <p class="liR sel" :class="{'noGrey':position != '请选择挂科地区'}" @click="openCity(1)">
                <span>{{position}}</span>
              </p></li>

            <li><span class="liL">挂科市</span>
              <p class="liR" :class="{'noGrey':cxs != '请填写挂科市'}"><input type="text"
                                                                                        placeholder="请填写挂科市"
                                                                                        v-model="cxs"></p></li>

            <li><span class="liL">挂科区/县</span>
              <p class="liR" :class="{'noGrey':cxx != '请填写挂科区/县'}"><input type="text"
                                                                                        placeholder="请填写挂科区/县"
                                                                                        v-model="cxx"></p></li>

            <li><span class="liL">挂科考场名称</span>
              <p class="liR" :class="{'noGrey':cxkcmc != '请填写挂科考场名称'}"><input type="text"
                                                                                        placeholder="请填写挂科考场名称"
                                                                                        v-model="cxkcmc"></p></li>

            <li><span class="liL">驾校所在地区</span>
              <p class="liR" :class="{'noGrey':jxPosition != '请选择驾校所在地'}">
                <span>{{jxPosition}}</span></p></li>
            <li><span class="liL">补偿科目</span>
              <p class="liR sel" :class="{'noGrey':claimClass != '请选择补偿科目'}" @click="openClaimClass">
                <span>{{claimClass}}</span></p></li>
            <li><span class="liL">考试结果</span>
              <p class="liR" :class="{'noGrey':result != '请选择考试结果'}"><span>{{result}}</span></p>
            </li>
            <li><span class="liL">考试成绩</span>
              <p class="liR"><input type="number" placeholder="请填写考试成绩" :class="{'noGrey':score != ''}" v-model="score">
              </p>
            </li>
            <li><span class="liL">交管12123密码</span>
              <p class="liR"><input type="text" placeholder="交管12123密码" :class="{'noGrey':password122 != ''}"
                                    v-model="password122"></p></li>
            <li><span class="liL">补偿金额</span>
              <p class="liR"><input type="text" placeholder="0" :class="{'noGrey':claimFee != '0'}" v-model="claimFee"
                                    ></p></li>
            <li><span class="liL">是否自动截图</span>
              <p class="liR">
                <van-radio-group v-model="autoFee" >
                  <van-radio style="margin: 5px 0px" name="1">自动截图</van-radio>
<!--                  <van-radio name="2">手动上传</van-radio>-->
                </van-radio-group>

              </p></li>
          </ul>
          <ul class="h5Camera" style="display: flex;flex-wrap: wrap" v-if="autoFee == '2'">
            <li><span class="title" style="color: #000">学员信息页</span>
              <p class="liR"> <van-uploader
                v-model="stuInfoUrl"
                preview-size="100px"
                :after-read="(file)=>{afterRead(file, 10)}"
                :before-read="beforeRead"
                @delete="(file)=>{deletePhoto(file, 2)}"
                :max-count="1"/></p></li>
            <li><span class="title" style="color: #000">考试成绩页</span>
              <p class="liR"> <van-uploader
                v-model="testScoreUrl"
                preview-size="100px"
                :after-read="(file)=>{afterRead(file, 11)}"
                :before-read="beforeRead"
                @delete="(file)=>{deletePhoto(file, 2)}"
                :max-count="1"/></p></li>
            <li><span class="title" style="color: #000">首次科目一预约页</span>
              <p class="liR"> <van-uploader
                v-model="firstDetailUrl"
                preview-size="100px"
                :after-read="(file)=>{afterRead(file, 12)}"
                :before-read="beforeRead"
                @delete="(file)=>{deletePhoto(file, 2)}"
                :max-count="1"/></p></li>
            <li><span class="title" style="color: #000">挂科科目预约页</span>
              <p class="liR"> <van-uploader
                v-model="incidentSubjectUrl"
                preview-size="100px"
                :after-read="(file)=>{afterRead(file, 13)}"
                :before-read="beforeRead"
                @delete="(file)=>{deletePhoto(file, 2)}"
                :max-count="1"/></p></li>
            <li><span class="title" style="color: #000">考试费缴纳页</span>
              <p class="liR"> <van-uploader
                v-model="testFeeUrl"
                preview-size="100px"
                :after-read="(file)=>{afterRead(file, 14)}"
                :before-read="beforeRead"
                @delete="(file)=>{deletePhoto(file, 2)}"
                :max-count="1"/></p></li>
            <li><span class="title" style="color: #000">考试费缴纳页(待缴费)</span>
              <p class="liR">
                <van-uploader
                v-model="waitTestFeeUrl"
                preview-size="100px"
                :after-read="(file)=>{afterRead(file, 15)}"
                :before-read="beforeRead"
                @delete="(file)=>{deletePhoto(file, 2)}"
                :max-count="1"/></p></li>
          </ul>
          <p class="tips">
            <van-icon name="info"/>
            <span class="spL">温馨提示: </span>
            <span class="spR"><code>1、实际补偿金额以当地车管所为准!</code><br><code>2、挂科日期需要在服务有效期内，有效期1年。</code><br>
<!--              <code>3、挂科后需在30 天内发起补偿，超过30 天无法补偿。</code>-->
</span>
          </p>
          <div class="photo" data-type="1">
            <p class="title">证件照上传</p>
            <ul class="h5Camera">
              <li class="front">
                <span class="title">身份证正面</span>
                <van-uploader
                  v-model="fileListFront"
                  preview-size="100px"
                  :after-read="(file)=>{afterRead(file, 1)}"
                  :before-read="beforeRead"
                  @delete="(file)=>{deletePhoto(file, 2)}"
                  :max-count="1"/>
              </li>
              <li class="behind">
                <span class="title">身份证反面</span>
                <van-uploader
                  v-model="fileListBack"
                  preview-size="100px"
                  :after-read="(file)=>{afterRead(file, 2)}"
                  :before-read="beforeRead"
                  @delete="(file)=>{deletePhoto(file, 2)}"
                  :max-count="1"/>
              </li>
            </ul>
          </div>
          <div class="sign">
              <a href="javascript:void(0)" class="btn"  @click="gotoSign"> 手写签名</a>
          </div>
        </van-collapse-item>
      </van-collapse>
      <p class="protocol">
        <van-checkbox v-model="checked"  @change="readBook"  icon-size="18px">我已阅读
<!--          <i @click.stop="openProtocol">《个人信息使用授权书》</i>并同意授权-->
        </van-checkbox>
      </p>
      <!-- 签名组件 -->
      <van-dialog v-model:show="signShow" title="手写签名" :show-cancel-button="false" :showConfirmButton="false" :width="isPhone?'100%':'900px'" :style="{top:isPhone?'50%':''}">
                <signer @set-sign="setSign"></signer>
                </van-dialog>
      <div v-if="openBtn" class="btn" @click="submit"><span>下一步</span></div>
    </div>
    <van-datetime-picker
      v-if="datetimeFlag"
      v-model="currentDate"
      type="date"
      title=""
      :formatter="formatter"
      @cancel="cancelDatetime"
      @confirm="queryTime"
    />
    <van-picker
      v-if="provinceListShowFlag"
      title=""
      show-toolbar
      :columns="provinceList"
      @confirm="onConfirmCity"
      @cancel="onCancelCity"
    />
    <van-picker
      v-if="claimClassShowFlag"
      title=""
      show-toolbar
      :columns="claimClassList"
      @confirm="onConfirmClaimClass"
      @cancel="onCancelClaimClass"
    />
    <van-picker
      v-if="resultShowFlag"
      title=""
      show-toolbar
      :columns="resultList"
      @confirm="onConfirmResult"
      @cancel="onCancelResult"
    />
    <popup ref="popupShows"></popup>
    <ajaxLoading ref="loading"></ajaxLoading>
    <maskPopup ref="maskShow"></maskPopup>
    <div class="protocolDetail" v-show="protocolDetailFlag">
      <h3>云南祐祉商务信息咨询有限公司</h3>
      <div class="protocolDetailBox">
        <p style="font-weight: bold;">
          【特别提醒】在您（以下亦称“本人”）确认本《个人信息使用授权书》（以下简称“本授权书”）之前，请您务必充分阅读本授权书所有内容。由于本授权书内容对您至关重要，如您对本授权书内容有任何疑问，请立即暂停后续操作。一旦您通过本网络服务页面进行确认，即视为您同意以数据电文形式签署本授权书。</p>
        <p>致：云南祐祉商务信息咨询有限公司（以下称“贵公司”）</p>
        <p>
          本人为贵公司代理推广的保险产品中被保险人，现本人拟通过贵公司向（具体以实际承保的为准）提交补偿申请。贵公司和在补偿过程中需收集、了解、使用本人的个人信息资料，用于每次（每笔）补偿中的审核（以下简称“审核”），故本人自愿同意并不可撤销，特做出以下操作授权：</p>
        <p>1、贵公司有权在收到本人补偿申请后进行下列操作，即采集、查询、验证、整理、保存本人提交的全部信息（简称“申请补偿信息”），并将本人每次申请补偿的信息提供给，由对本人进行审核。</p>
        <p>2、贵公司有权从处获得本人的补偿审核结果及相关信息，并有权保存全部相关信息供本人进行查询。</p>
        <p>
          3、本人确认本授权书所称本人“个人信息”，包括但不限于如下内容：本人姓名、证件类型、证件号码、证件影印件、联系方式、性别、住址、电子邮箱、财务信息、征信信息、个人健康信息、车辆信息等，具体以本人实际提供的个人信息和反馈的信息为准。</p>
        <p>4、贵公司及收到本人申请补偿信息的，均有权按如下用途及方式使用本人个人信息：</p>
        <p>（1）审核本人提交的每个补偿申请；</p>
        <p>（2）进行客户身份信息识别；</p>
        <p>（3）履行反洗钱义务；</p>
        <p>（4）监管机构规定需要使用本人个人信息的情况。</p>
        <p>5、本人因投保和补偿需要，授权贵公司在本人投保保单成功生效后，通过公安部交通安全综合服务管理平台（www.122.gov.cn）查询本人相关的交管、驾考信息等内容。</p>
        <p>6、本授权书有效期限约定为自本人做出本授权承诺之日起至补偿完成，或补偿申请被拒绝之日止。</p>
        <p>本人已知悉本授权书上述全部内容的含义及因此产生的法律效力【包括但不限于：上述信息对本人是否可以成功补偿、以及补偿金额等结果产生不利影响的风险】。 本授权书完全是本人真实意思表示，本人同意承担由此产生的一切法律后果。
          本授权书效力具有独立性，不因相关保险合同或条款无效或被撤销而无效或失效，本授权书一经签署，便不可撤销。</p>
        <div class="sign">
          <p>授权人签字：{{userName}}</p>
          <p>{{new Date().getFullYear()}}年{{new Date().getMonth()+1}}月{{new Date().getDate()}}日</p>
        </div>
      </div>
      <img src="../../assets/img/closeImg.png" alt="" @click="closeProtocol">
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue';
import popup from '../common/commonComponents/popup';
import ajaxLoading from '../common/commonComponents/loading';
import maskPopup from '../common/commonComponents/maskDiv';
import {Config, ROUTES} from "../common/api";
import './../common/reset.scss';
import './../common/common';
import signer from './../sign/signer';
import {DatetimePicker, Picker, Checkbox, Uploader, Toast, Dialog, Collapse, CollapseItem, Field } from 'vant';

Vue.use(DatetimePicker).use(Picker).use(Checkbox).use(Uploader).use(Toast).use(Dialog).use(Collapse).use(CollapseItem).use(Field);

export default {
  name: "applyClaim",
  data() {
    return {
      signShow: false,
      accountFlag: '0', // 账户类型 0 第三方账号  1 个人账户
      activeNames: ['2'],
      ajaxState: true, // 防止重复提交，调用多次接口
      selCurrentDate: '请选择挂科日期',
      currentDate: new Date(),
      position: '请选择挂科地区',
      positionCode: '',
      jxPosition: '请选择驾校所在地',
      jxPositionCode: '',
      claimClass: '请选择补偿科目',
      cxs: '',
      cxx: '',
      cxkcmc: '',
      claimClassCode: '',
      result: '未通过',
      resultCode: '2',
      score: '',
      claimFee: '0',
      password122: '',
      minDate: new Date(2010, 0, 1), // 最小日期
      maxDate: new Date(2045, 10, 1), // 最大日期
      datetimeFlag: false, // 日期选择弹框
      provinceList: [],
      provinceListShowFlag: false,
      claimClassList: [],
      claimClassShowFlag: false,
      openBtn:true,
      resultList: [],
      resultShowFlag: false,
      popupType: 1, // 地市弹框类型
      provinceListInit: [], // 初始数据
      subjectListInit: [], // 初始数据
      resultListInit: [], // 初始数据
      checked: false, // 勾选协议
      protocolDetailFlag: false, // 协议弹框
      userName: '', // 用户名称
      fileListFront: [], //身份证正面
      fileListBack: [], //身份证反面面
      resizeCount: 1, // 图片缩放比例
      payeeName: '', // 收款人姓名
      payeeCertNo: '', // 收款人身份证号
      payeePhone: '', // 收款人电话
      bankCode: '', // 支付宝账号
      bankName: '', // 银行名称
      bankProvinceName: '', // 银行所在省份
      bankCityName: '', // 银行所在地市
      bankSubName: '', // 银行所在地市
      initFlag: false, // 初始化状态
      bankList: [], // 银行名称列表
      bankListFlag: false, // 银行名称列表展示标识
      subBankList: [], // 银行支行名称
      loading:false,
      show: false,
      signUrl: '',
      isPhone:true,
      bankSubSelectShow:false,
      firstDetailUrl:[],
      waitTestFeeUrl:[],
      testFeeUrl:[],
      stuInfoUrl:[],
      testScoreUrl:[],
      incidentSubjectUrl:[],
    //   自动截图
      autoFee:'0'
    };
  },
  components: {
    popup,
    ajaxLoading,
    maskPopup,signer
  },
  mounted() {
    document.title = '挂科信息';
    this.init();
    const bdOrderInfo = JSON.parse(localStorage.getItem('bdOrderInfo'));
    this.jxPosition=bdOrderInfo.schoolAreaName;
    this.jxPositionCode=bdOrderInfo.schoolAreaNo;
    this.minDate = new Date(bdOrderInfo.insuranceStartTime || '2022-01-01');
    this.maxDate = new Date(bdOrderInfo.insuranceEndTime || '2032-01-01');

    var userAgent = navigator.userAgent;

    // 定义正则表达式进行匹配
    var isMobileRegex = /(Android|iPhone|SymbianOS|Windows Phone)/i;

    if (isMobileRegex.test(userAgent)) {
        console.log("这是移动设备"); // PC端输出"这是移动设备"
    } else {
        console.log("这是PC端"); // 移动端输出"这是PC端"
        this.isPhone = false
    }
  },
  methods: {
    bankSubNameClick(){
      this.bankSubSelectShow = true
    },
    bankSubNameBlur(){
      this.bankSubSelectShow = false
    },
    gotoSign(){
      this.signShow = true;

    },
    readBook(val){
       if(val){
          this.gotoSign();
       }
    },
    //子组件回调
    setSign(signUrl){
      this.signUrl = signUrl;
      this.signShow = false;
    },
    // 上传前
    deletePhoto(file, type) {
      const url = Config.api_url + "applets-server/api/minio/remove/cert";
      const that = this;
      this.$refs.loading.loadingFlag = true;
      this.$ajax({
        method: "post",
        url: url,
        withCredentials: false,
        data: {
          fileName: file.img
        },
        headers: {'Content-Type': 'application/json'}
      }).then(function (res) {
        self.ajaxState = true;
        const data = res.data;
        if (data.success) {

        } else {
          Toast(data.errorMessage || '接口失败，请重试！');
        }
        that.$refs.loading.loadingFlag = false;
      }).catch(function (err) {
        that.$refs.loading.loadingFlag = false;
        Toast('网络异常，请重试！');
      });
    },
    // 上传前
    beforeRead(file) {
      if (file.size > 10 * 1024 * 1024) {
        this.resizeCount = 1;
        Toast('图片大小不能超过10M');
        return false;
      }
      return true;
    },
    // 上传后
    afterRead(file, type) {
      console.log(file);
      this.$refs.loading.loadingFlag = true;
      const url = Config.api_url + 'applets-server/api/minio/upload/cert/image';
      const that = this;
      let config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      };
      let formdata = new FormData();
      let canvas = document.createElement('canvas'); // 创建Canvas对象(画布)
      let context = canvas.getContext('2d');
      let img = new Image();
      img.src = file.content; // 指定图片的DataURL(图片的base64编码数据)
      console.log('0', file.content.length / 1024);
      const imageSize = file.content.length || 100;
      if (imageSize <= 10 * 1024 * 1024 && imageSize > 8 * 1024 * 1024) {
        this.resizeCount = 3;
      } else if (imageSize <= 8 * 1024 * 1024 && imageSize > 6 * 1024 * 1024) {
        this.resizeCount = 3;
      } else if (imageSize <= 6 * 1024 * 1024 && imageSize > 4 * 1024 * 1024) {
        this.resizeCount = 2.5;
      } else if (imageSize <= 4 * 1024 * 1024 && imageSize > 2 * 1024 * 1024) {
        this.resizeCount = 1.5;
      } else {
        this.resizeCount = 1;
      }
      console.log(this.resizeCount);
      img.onload = () => {
        if (this.resizeCount > 1) {
          canvas.width = img.width / this.resizeCount;
          canvas.height = img.height / this.resizeCount;
          context.drawImage(img, 0, 0, img.width / this.resizeCount, img.height / this.resizeCount);
          file.content = canvas.toDataURL(file.file.type, 1);
        }
        let files = this.dataURLtoFile(file.content, file.file.name);
        formdata.append('file', files);
        console.log('1', file.content.length / 1024);
        formdata.append('token', localStorage.getItem('infoToken'));
        this.$ajax.post(url, formdata, config).then(function (res) {
          that.$refs.loading.loadingFlag = false;
          const data = res.data;
          if (data.success) {
            if (type == '1') {
              that.fileListFront[0].img = data.data;
            } else if (type == '2') {
              that.fileListBack[0].img = data.data;
            } else if (type == '10') {
              that.stuInfoUrl[0].img = data.data;
            } else if (type == '11') {
              that.testScoreUrl[0].img = data.data;
            }else if (type == '12') {
              that.firstDetailUrl[0].img = data.data;
            }else if (type == '13') {
              that.incidentSubjectUrl[0].img = data.data;
            }else if (type == '14') {
              that.testFeeUrl[0].img = data.data;
            }else if (type == '15') {
              that.waitTestFeeUrl[0].img = data.data;
            }
          } else {
            Toast(data.errorMessage || '接口失败，请重试！');
            if (type == '1') {
              that.fileListFront = [];
            } else if (type == '2'){
              that.fileListBack = [];
            }else if (type == '10') {
              that.stuInfoUrl = [];
            } else if (type == '11') {
              that.testScoreUrl = [];
            }else if (type == '12') {
              that.firstDetailUrl = [];
            }else if (type == '13') {
              that.incidentSubjectUrl = [];
            }else if (type == '14') {
              that.testFeeUrl = [];
            }else if (type == '15') {
              that.waitTestFeeUrl = [];
            }
          }
        }).catch(function (err) {
          that.$refs.loading.loadingFlag = false;
          if (type == '1') {
            that.fileListFront = [];
          } else {
            that.fileListBack = [];
          }
          Toast('网络异常，请重试！');
        });
      }
    },
    // 将base64转换为file文件
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    // 打开时间弹框
    openDatetime() {
      this.datetimeFlag = true;
      this.$refs.maskShow.maskFlag = true;
    },
    // 关闭时间弹框
    cancelDatetime() {
      this.datetimeFlag = false;
      this.$refs.maskShow.maskFlag = false;
    },
    // 格式化时间
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    // 确认时间
    queryTime() {
      this.datetimeFlag = false;
      this.$refs.maskShow.maskFlag = false;
      const date = new Date(this.currentDate);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let day = date.getDate();
      day = day < 10 ? '0' + day : day;
      this.selCurrentDate = year + '-' + month + '-' + day;
    },
    // 打开地市弹框
    openCity(type) {
      this.popupType = type;
      this.provinceListShowFlag = true;
      this.$refs.maskShow.maskFlag = true;
    },
    // 地区确认
    onConfirmCity(value, index) {
      if (this.popupType == 1) {
        this.position = value;
        this.positionCode = this.provinceListInit[index].areaCode;
      } else {
        this.jxPosition = value;
        this.jxPositionCode = this.provinceListInit[index].areaCode;
      }
      this.provinceListShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
      this.claimFee = 0;
      this.getClaimFee();
    },
    // 地区取消
    onCancelCity() {
      this.provinceListShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
    },
    // 打开补偿科目弹框
    openClaimClass() {
      this.claimClassShowFlag = true;
      this.$refs.maskShow.maskFlag = true;
    },
    // 补偿科目确认
    onConfirmClaimClass(value, index) {
      this.claimClass = value;
      this.claimClassCode = this.subjectListInit[index].subjectId;
      this.claimClassShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
      this.claimFee = 0;
      this.getClaimFee();
    },
    // 补偿科目取消
    onCancelClaimClass() {
      this.claimClassShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
    },
    // 打开考试结果弹框
    openResult() {
      this.resultShowFlag = true;
      this.$refs.maskShow.maskFlag = true;
    },
    // 考试结果确认
    onConfirmResult(value, index) {
      console.log('value', value);
      this.result = value;
      this.resultCode = this.resultListInit[index].resultId;
      this.resultShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
    },
    // 考试结果取消
    onCancelResult() {
      this.resultShowFlag = false;
      this.$refs.maskShow.maskFlag = false;
    },
    // 必填校验
    valueCheck(value, checkValue, tips) {
      if (value == checkValue) {
        this.$refs.popupShows.popupShowing(tips);
        return true;
      }
      return false;
    },
    // 提交校验
    preCheck() {
      if (this.accountFlag == '1') {
        if (this.valueCheck(this.payeeName, '', '请填写收款人姓名')) {
          return true;
        }

        if (this.valueCheck(this.cxs, '', '请填写挂科市')) {
          return true;
        }
        if (this.valueCheck(this.cxx, '', '请填写挂科区/县')) {
          return true;
        }
        if (this.valueCheck(this.cxkcmc, '', '请填写挂科驾校名称')) {
          return true;
        }

        if (this.valueCheck(this.payeeCertNo, '', '请填写收款人身份证号')) {
          return true;
        }
        if (this.valueCheck(this.payeePhone, '', '请填写收款人电话')) {
          return true;
        }
        if (this.valueCheck(this.bankCode, '', '请填写银行账号')) {
          return true;
        }
        if (this.valueCheck(this.bankName, '', '请填写银行名称')) {
          return true;
        }
        if (this.valueCheck(this.bankProvinceName, '', '请填写银行所在省份')) {
          return true;
        }
        if (this.valueCheck(this.bankCityName, '', '请填写银行所在地市')) {
          return true;
        }
        if (this.valueCheck(this.bankSubName, '', '请填写开户支行')) {
          return true;
        }
        if (this.valueCheck(this.signUrl, '', '请手写签名')) {
          return true;
        }
      }
      if (this.valueCheck(this.selCurrentDate, '请选择挂科日期', '请选择挂科日期')) {
        return true;
      }
      if (this.valueCheck(this.position, '请选择挂科地区', '请选择挂科地区')) {
        return true;
      }
      if (this.valueCheck(this.jxPosition, '请选择驾校所在地', '请选择驾校所在地')) {
        return true;
      }
      if (this.valueCheck(this.claimClass, '请选择补偿科目', '请选择补偿科目')) {
        return true;
      }
      if (this.valueCheck(this.result, '请选择考试结果', '请选择考试结果')) {
        return true;
      }
      if (this.valueCheck(this.score, '', '请填写考试成绩')) {
        return true;
      }
      if (this.valueCheck(this.claimFee, '0', '补偿金额为0，不可补偿')) {
        return true;
      }
      if (this.valueCheck(this.password122, '', '交管12123密码')) {
        return true;
      }
      return false;
    },
    // 提交
    submit() {

      if (this.autoFee == '0'){
        this.$refs.popupShows.popupShowing('请选择是否自动截图！');
        return;
      }

      if (this.preCheck()) {
        return;
      }
      // 如果是手动上传
      if (this.autoFee == '2'){
      //   判断图片
        if (this.stuInfoUrl.length == 0 || this.stuInfoUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传学员信息页！');
          return;
        }
        if (this.testScoreUrl.length == 0 || this.testScoreUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传考试成绩页！');
          return;
        }
        if (this.firstDetailUrl.length == 0 || this.firstDetailUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传首次科目一预约详情页！');
          return;
        }
        if (this.incidentSubjectUrl.length == 0 || this.incidentSubjectUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传挂科科目预约详情页！');
          return;
        }
        if (this.testFeeUrl.length == 0 || this.testFeeUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传考试费已缴纳页！');
          return;
        }
        if (this.waitTestFeeUrl.length == 0 || this.waitTestFeeUrl.length == 0) {
          this.$refs.popupShows.popupShowing('请先上传考试费待缴纳页！');
          return;
        }
      }
      if (this.fileListFront.length == 0 || this.fileListBack.length == 0) {
        this.$refs.popupShows.popupShowing('请先上传证件照！');
        return;
      }
      if (!this.checked) {
        this.$refs.popupShows.popupShowing('请先同意授权！');
        return;
      }
      if(!this.signUrl || this.signUrl ==''){
        this.$refs.popupShows.popupShowing('请完成手写签名');
        return;
      }
      let self = this;

      if (!this.ajaxState) {
        return;
      }
      this.ajaxState = false;
      const url = Config.api_url + "applets-server/api/policy/save";
      this.$refs.loading.loadingFlag = true;
      console.log("this.stuInfoUrl",this.stuInfoUrl)
      this.$ajax({
        method: "post",
        url: url,
        withCredentials: false,
        data: {
          claimAmount: this.claimFee,
          claimSubjectName: this.claimClass,
          claimSubjectNo: this.claimClassCode,
          examResultsName: this.result,
          examResultsNo: this.resultCode,
          examScore: this.score,
          policyAreaName: this.position,
          policyAreaNo: this.positionCode,
          policyTime: this.selCurrentDate,
          schoolAreaName: this.jxPosition,
          schoolAreaNo: this.jxPositionCode,
          password122: this.password122,
          token: localStorage.getItem('infoToken'),
          payeeName: this.payeeName,
          payeeCertNo: this.payeeCertNo,
          payeePhone: this.payeePhone,
          bankCode: this.bankCode,
          bankName: this.bankName,
          bankProvinceName: this.bankProvinceName,
          bankCityName: this.bankCityName,
          bankSubName: this.bankSubName,
          certFile: this.fileListFront[0].img + '|' + this.fileListBack[0].img,
          positiveImage: this.fileListFront[0].img,
          negativeImage: this.fileListBack[0].img,
          signUrl: this.signUrl,
          cxx: this.cxx,
          cxs: this.cxs,
          cxkcmc: this.cxkcmc,
          autoFee:this.autoFee,
          stuInfoUrl: this.stuInfoUrl.length > 0 ? this.stuInfoUrl[0].img : '',
          testScoreUrl: this.testScoreUrl.length > 0 ? this.testScoreUrl[0].img : '',
          firstDetailUrl: this.firstDetailUrl.length > 0 ? this.firstDetailUrl[0].img : '',
          incidentSubjectUrl: this.incidentSubjectUrl.length > 0 ? this.incidentSubjectUrl[0].img : '',
          testFeeUrl: this.testFeeUrl.length > 0 ? this.testFeeUrl[0].img : '',
          waitTestFeeUrl: this.waitTestFeeUrl.length > 0 ? this.waitTestFeeUrl[0].img : '',
        },
        headers: {'Content-Type': 'application/json'}
      }).then(function (res) {
        self.ajaxState = true;
        const data = res.data
        if (data.success) {
          const bdOrderInfo = JSON.parse(localStorage.getItem('bdOrderInfo'));
          bdOrderInfo.claimClassCode = self.claimClassCode;
          bdOrderInfo.policyId = data.data;
          bdOrderInfo.policyTime = self.selCurrentDate
          localStorage.setItem('bdOrderInfo', JSON.stringify(bdOrderInfo));
          if (self.autoFee == '1'){

            setTimeout(() => {
              self.$router.push('/login');
            }, 1000)
          }else {
            self.$refs.popupShows.popupShowing('提交成功!!!!!');
            self.openBtn = false
          }
        } else {
          self.$refs.popupShows.popupShowing(data.errorMessage);
        }
        self.$refs.loading.loadingFlag = false;
      }).catch(function (err) {
        self.ajaxState = true;
        self.$refs.loading.loadingFlag = false;
        self.$refs.popupShows.popupShowing('网络异常，请重试！');
      });
    },
    // 初始化
    init() {
      let self = this;
      const url = Config.api_url + "applets-server/api/policy/init";
      this.$refs.loading.loadingFlag = true;
      this.$ajax({
        method: "get",
        url: url,
        withCredentials: false,
        params: {
          token: localStorage.getItem('infoToken'),
        },
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }).then(function (res) {
        const data = res.data;
        if (data.success) {
          self.userName = data.data.userName || '';
          self.provinceListInit = data.data.provinceList || [];
          self.subjectListInit = data.data.subjectList || [];
          self.resultListInit = data.data.resultList || [];
          for (let p in self.provinceListInit) {
            self.provinceList.push(self.provinceListInit[p].areaName);
          }
          for (let s in self.subjectListInit) {
            self.claimClassList.push(self.subjectListInit[s].subjectName);
          }
          for (let r in self.resultListInit) {
            self.resultList.push(self.resultListInit[r].resultName);
          }
          const policy = data.data.policy || {};
          self.claimFee = policy.claimAmount || '';
          self.claimClass = policy.claimSubjectName || '请选择补偿科目';
          self.claimClassCode = policy.claimSubjectNo || '';
          self.result = '未通过';
          self.resultCode = '2';
          self.score = policy.examScore || '';
          self.position = policy.policyAreaName || '请选择挂科地区';
          self.positionCode = policy.policyAreaNo || '';
          self.selCurrentDate = policy.policyTime || '请选择挂科日期';
          /*self.jxPosition = policy.schoolAreaName || '请选择驾校所在地';
          self.jxPositionCode = policy.schoolAreaNo || '';*/
          self.password122 = policy.password122 || '';
          self.payeeName = policy.payeeName || '';
          self.payeeCertNo = policy.payeeCertNo || '';
          self.payeePhone = policy.payeePhone || '';
          self.bankCode = policy.bankCode || '';
          self.bankName = policy.bankName || '';
          self.bankProvinceName = policy.bankProvinceName || '';
          self.bankCityName = policy.bankCityName || '';
          self.bankSubName = policy.bankSubName || '';
          self.initFlag = true;
          if (policy.positiveImage) {
            self.fileListFront = [{
              url: policy.positiveImage,
              img: policy.positiveImage
            }];
          }
          if (policy.negativeImage) {
            self.fileListBack = [{
              url: policy.negativeImage,
              img: policy.negativeImage
            }];
          }
          self.accountFlag = data.data.accountFlag || '0';
          if (self.accountFlag == '1') {
            self.activeNames = ['1', '2'];
          }
        } else {
          Dialog.alert({
            showConfirmButton: false,
            message: data.errorMessage,
          }).then(() => {
            // on close
          });
        }
        self.$refs.loading.loadingFlag = false;
      }).catch(function (err) {
        self.$refs.loading.loadingFlag = false;
      });
    },
    // 获取补偿金额
    getClaimFee() {
      const that = this;
      if (that.positionCode && that.claimClassCode) {
        const url = Config.api_url + "/applets-server/api/policy/claim/amount";
        this.$ajax({
          method: "get",
          url: url,
          withCredentials: false,
          params: {
            areaCode: that.positionCode,
            token: localStorage.getItem('infoToken'),
          },
          headers: {'Content-Type': 'application/json'}
        }).then(function (res) {
          const data = res.data;
          if (data.success && data.data) {
            const resData = data.data;
            if (that.claimClassCode == '01' && resData.subjectOneAmount != '0') {
              that.claimFee = resData.subjectOneAmount;
            } else if (that.claimClassCode == '02' && resData.subjectTwoAmount != '0') {
              that.claimFee = resData.subjectTwoAmount;
            } else if (that.claimClassCode == '03' && resData.subjectThreeAmount != '0') {
              that.claimFee = resData.subjectThreeAmount;
            } else if (that.claimClassCode == '04' && resData.subjectFourAmount != '0') {
              that.claimFee = resData.subjectFourAmount;
            } else {
              that.$refs.popupShows.popupShowing('对不起，暂不支持补偿！');
            }
          } else {
            that.$refs.popupShows.popupShowing(data.errorMessage);
          }
        }).catch(function (err) {
          that.$refs.popupShows.popupShowing('网络异常，请重试！');
        });
      }
    },
    // 打开协议
    openProtocol() {
      this.$refs.maskShow.maskFlag = true;
      this.protocolDetailFlag = true;
    },
    // 关闭协议
    closeProtocol() {
      this.$refs.maskShow.maskFlag = false;
      this.protocolDetailFlag = false;
    },
    // 选择银行名
    selBankList(item) {
      this.bankName = item.bankName;
      this.bankListFlag = false;
    },
    querySubBank(bankSubName){
      let self = this
      const url = Config.api_url + "applets-server/api/policy/bankQuery";
      this.loading=true
      this.$ajax({
        method:"post",
        url:url,
        data:{
          bankCode:this.bankCode,
          bankName:this.bankName,
          bankCityName:this.bankCityName,
          bankProvinceName:this.bankProvinceName,
          bankSubName:bankSubName,
        },
        headers: {'Content-Type': 'application/json'}
      }).then(function (res) {
        const data = res.data;
        if (data.success) {
          self.subBankList = data.data
          self.loading=false
        }else{
          self.subBankList =[]
          self.loading=false
        }
      }).catch(function (err) {
        console.log(err)
        self.loading=false
      });
    }
  },
  watch: {
    bankCode() {
      if (this.initFlag) {
        this.initFlag = false;
        return;
      }
      if (this.bankCode.length < 12) {
        return;
      }
      const that = this;
      that.bankName = '';
      that.bankListFlag = false;
      const url = Config.api_url + "applets-server/api/bank/name";
      this.$ajax({
        method: "get",
        url: url,
        withCredentials: false,
        params: {
          bankCode: this.bankCode,
          token: localStorage.getItem('infoToken'),
        },
        headers: {'Content-Type': 'application/json'}
      }).then(function (res) {
        const data = res.data;
        if (data.success && data.data) {
          const resData = data.data;
          that.bankName = resData.bankName;
        } else {
        }
      }).catch(function (err) {
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.van-cell {
  background-color: #2486ff !important;
  color: #fff !important;
  font-size: 16px !important;
}
.liR{
  .van-cell {
    background-color: #fff !important;
    color: #fff !important;
    font-size: 15px !important;
    padding: 0;
  }
}

.van-cell__right-icon {
  color: #fff !important;
  font-size: 16px !important;
}
</style>
<style lang="scss" scoped>
$them: #067adc;
* {
  margin: 0;
  padding: 0;
}

.main {
  overflow: hidden;
  background: #ededed;
  min-height: 100%;
  [disabled] {
    background: #fff;
  }
  .message {
    width: 375px;
    /*padding: 0 10px;*/
    box-sizing: border-box;
    border-radius: 4px;
    background: #fff;
    .messageUl {
      li {
        box-sizing: border-box;
        border-bottom: 1px solid #eeeeee;
        padding: 10px 0;
        line-height: 26px;
        display: flex;
        font-size: 15px;
        position: relative;
        .liL {
          float: left;
          width: 150px;
          color: #1b1b1b;
        }
        .liR {
          flex: 1;
          color: #999;
          position: relative;
          input {
            display: block;
            height: 26px;
            line-height: 26px;
            border: none;
            font-size: 15px;
            width: 100%;
            &.noGrey {
              color: #1b1b1b;
            }
          }
          &.sel {
            &:after {
              content: '';
              width: 9px;
              height: 9px;
              background: transparent;
              border-top: 1px solid #999;
              border-right: 1px solid #999;
              border-left: none;
              border-bottom: none;
              transform: rotate(45deg) translateY(-50%);
              position: absolute;
              top: 46%;
              z-index: 1;
              right: 10px;
            }
          }
          &.noGrey {
            color: #1b1b1b;
          }
        }
        .bankList{
          position: absolute;
          z-index: 100;
          width: 100%;
          display: block;
          left: 0;
          top: 47px;
          background: #fff;
          box-shadow: 0 0 5px 1px #ccc;
          border-radius: 4px;
          padding: 5px 0;
          color: #000000;
          span{
            display: block;
            width: 100%;
            line-height: 30px;
            font-style: normal;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
            font-size: 14px;
            padding: 0 10px;
          }
        }
      }
    }
    .tips {
      margin-top: 5px;
      color: #f60f60;
      font-size: 13px;
      .van-icon:before {
        margin-top: 3px;
      }
      .spR {
        display: block;
        padding-left: 20px;
      }
    }
    .btn {
      padding: 15px 10px;
      span {
        display: block;
        font-size: 15px;
        text-align: center;
        color: #fff;
        line-height: 45px;
        background: #2486ff;
        border-radius: 4px;
      }
    }
  }
  .protocol {
    padding: 0 10px;
    margin-top: 5px;
    font-size: 12px;
    i {
      font-style: normal;
      color: #2486ff;
    }
  }
}

.popup {
  width: 100%;
  padding: 0 0.75rem;
  background-color: transparent;
  z-index: 1003;
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.protocolDetail {
  width: 90%;
  height: 80%;
  background-color: #fff;
  z-index: 2000;
  box-sizing: border-box;
  border-radius: 10px;
  position: fixed;
  top: 45%;
  left: 50%;
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  padding: 10px;
  font-size: 14px;
  .protocolDetailBox {
    padding: 10px 0;
    height: 85%;
    overflow: auto;
  }
  h3 {
    line-height: 30px;
    text-align: center;
  }
  p {
    text-indent: 1em;
    margin-bottom: 5px;
  }
  img {
    display: block;
    width: 30px;
    height: 30px;
    position: absolute;
    bottom: -43px;
    left: 50%;
    transform: translateX(-50%);
  }
  .sign {
    text-align: right;
    margin-bottom: 20px;
  }
}

input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
  font-size: 15px;
  color: #999;
}

.photo {
  padding: 12px 0;
  min-height: 130px;
  position: relative;
  border-top: 1px solid #eeeeee;
  margin-top: 10px;
  > .title {
    margin-bottom: 10px;
    color: #2486ff;
  }
  ul {
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    li {
      position: relative;
      width: 36%;
      text-align: center;
      float: left;
      background-size: 34px;
      height: 106px;
      margin-bottom: 10px;
      margin-left: 1.16%;
      margin-right: 1.16%;
      .title {
        display: block;
        color: #2486ff;
        font-size: 14px;
        margin-bottom: 5px;
      }

    }
  }
}
</style>
<style lang="scss">
.backCollapseItem{
  .van-collapse-item__wrapper{
    overflow:visible;
  }
  .bankSubNameSelectDwon{
    z-index: 999;
    font-size: 14px;
    background-color: #fff;
    border: 1px solid #DCDFE6;
    border-bottom: 0px;
    li{
      font-size: 10px !important;
      padding: 4px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// applyClaim.vue?7b4ed08b